import * as Yup from "yup";

export const bookingValidationSchema = Yup.object().shape({
  // vehicleType: Yup.string().required("Vehicle type is required"),
  partyData: Yup.object()
    .shape({
      partyName: Yup.string().required("Party name is required"),
      primaryContactName: Yup.string().required(
        "Primary contact name is required"
      ),
      primaryContactNumber: Yup.string()
        .required("Primary contact number is required")
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
      email: Yup.string().email("Invalid email format").optional(),
      address: Yup.string().optional(),
    })
    .required("Party details are required"),
  // vehicleNumber: Yup.string().when("vehicleType", {
  //   is: "SCHEDULED",
  //   then: (schema) => schema.optional().nullable(),
  //   otherwise: (schema) => schema.required("Vehicle number is required"),
  // }),
  odometerReading: Yup.number().optional(),
  journeyStartDateTime: Yup.date().required("Journey start date is required"),
  journeyEndDateTime: Yup.date().optional().nullable(),
  journeyStartLocation: Yup.string().required(
    "Journey start location is required"
  ),
  journeyEndLocation: Yup.string().required("Journey end location is required"),
  remarks: Yup.string().optional().nullable(),
});

export const incomeValidationSchema = Yup.object().shape({
  incomes: Yup.array()
    .of(
      Yup.object().shape({
        incomeType: Yup.string().required("Income type is required"),
        limit: Yup.number().when("incomeType", {
          is: "perkm",
          then: (schema) =>
            schema
              .required("Limit per km is required")
              .min(0, "Limit must be positive"),
          otherwise: (schema) => schema.optional().nullable(),
        }),
        amount: Yup.number().required("Amount is required"),
        overLimitKms: Yup.number().optional().nullable(),
        gstPercentage: Yup.number().optional().nullable(),
      })
    )
});
